<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Booker Tariff</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Markup
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    Markup <span><i class="ic-price-calculator"></i></span>
                  </h2>
                  <p>Set markup for Booker Tariffs.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Class</th>
                  <th>Has Markup</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.masterClassName }}</td>
                  <td
                    :class="{
                      '--green35': item.hasMarkup,
                      'sts-danger': !item.hasMarkup,
                    }"
                  >
                    {{ item.hasMarkup ? "Yes" : "No" }}
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="
                          isAllowToCreate || isAllowToUpdate || isAllowToDelete
                        "
                        class="btn btn-default"
                        type="button"
                        @click="manageMarkup(item)"
                      >
                        <span>Manage</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div
      class="modal fade"
      role="dialog"
      ref="vuemodal"
      id="modal-markup"
      v-if="selectedMasterClass"
    >
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-sell" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Markup ({{ selectedMasterClass.masterClassName }})</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <!-- Start: Form -->
                  <div class="row cRow">
                    <div class="pr-30 col-sm-12">
                      <div class="summary-error" v-if="$v.model.$error">
                        This form has errors
                      </div>
                      <form @submit.prevent="submit">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label class="required">Target (Level 1)</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.level1Target.$error,
                                }"
                                label="text"
                                v-model="model.level1Target"
                                :options="level1Targets"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                              ></v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.model.level1Target.required
                                "
                                >Target 1 is required</small
                              >
                            </div>
                          </div>
                          <div
                            class="col-sm-6"
                            v-if="model.level1Target === 'Service'"
                          >
                            <div class="form-group">
                              <label class="required">Target (Level 2)</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.level2Target.$error,
                                }"
                                label="text"
                                v-model="model.level2Target"
                                :options="level2Targets"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                              ></v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.model.level2Target.required
                                "
                                >Target 2 is required</small
                              >
                            </div>
                          </div>
                        </div>

                        <div class="row" v-if="isRental(model.level2Target)">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <div class="d-flex py-2">
                                <label class="required">Zone(s)</label>
                                <button
                                  type="button"
                                  class="btn-select-all ml-5"
                                  @click="onSelectAll('zone')"
                                >
                                  Select All
                                </button>
                                <button
                                  type="button"
                                  class="btn-clear-all ml-5"
                                  @click="onClearAll('zone')"
                                  v-if="hasZones"
                                >
                                  Clear All
                                </button>
                              </div>
                              <multiselect
                                v-model="model.zones"
                                :class="{
                                  'field-error':
                                    isSubmitted && !$v.model.zones.required,
                                }"
                                :options="zones"
                                :multiple="true"
                                :close-on-select="false"
                                placeholder="Select zone(s)"
                                label="label"
                                track-by="id"
                              />
                              <small
                                class="form-text sts-danger"
                                v-if="isSubmitted && !$v.model.zones.required"
                                >Zone(s) is required
                              </small>
                            </div>
                          </div>
                        </div>

                        <div
                          class="row"
                          v-if="
                            (isAirportWithinZone(model.level2Target) ||
                              isAirportZoneToZone(model.level2Target)) &&
                            isUpdate
                          "
                        >
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label
                                v-if="isAirportWithinZone(model.level2Target)"
                                class="required"
                                >Zone</label
                              >
                              <label v-else class="required"
                                >Pick-Up Zone</label
                              >
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.pickUpZoneId.$error,
                                }"
                                label="label"
                                v-model="model.pickUpZoneId"
                                :options="zones"
                                :clearable="false"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.id"
                              ></v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.model.pickUpZoneId.required
                                "
                              >
                                <template
                                  v-if="isAirportWithinZone(model.level2Target)"
                                  >Zone is required</template
                                >
                                <template v-else
                                  >Pick-Up Zone is required</template
                                >
                              </small>
                            </div>
                          </div>
                          <div
                            class="col-sm-6"
                            v-if="isAirportZoneToZone(model.level2Target)"
                          >
                            <div class="form-group">
                              <label class="required">Drop-Off Zone</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.dropOffZoneId.$error,
                                }"
                                label="label"
                                v-model="model.dropOffZoneId"
                                :options="zones"
                                :clearable="false"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.id"
                              ></v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.model.dropOffZoneId.required
                                "
                              >
                                Drop-Off Zone is required
                              </small>
                            </div>
                          </div>
                        </div>

                        <div
                          class="row"
                          v-if="
                            (isAirportWithinZone(model.level2Target) ||
                              isAirportZoneToZone(model.level2Target)) &&
                            !isUpdate
                          "
                        >
                          <div class="col-sm-6">
                            <div class="form-group">
                              <div class="d-flex py-2">
                                <label
                                  v-if="isAirportWithinZone(model.level2Target)"
                                  class="required"
                                  >Group Zone(s)</label
                                >
                                <label v-else class="required"
                                  >Pick-Up Group Zone(s)</label
                                >
                                <button
                                  type="button"
                                  class="btn-select-all ml-5"
                                  @click="onSelectAll('zoneGroupIds')"
                                >
                                  Select All
                                </button>
                                <button
                                  type="button"
                                  class="btn-clear-all ml-5"
                                  @click="onClearAll('zoneGroupIds')"
                                  v-if="hasZoneGroupIds"
                                >
                                  Clear All
                                </button>
                              </div>
                              <multiselect
                                v-model="model.zoneGroupIds"
                                @select="clearAmountType()"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    !$v.model.zoneGroupIds.required,
                                }"
                                :options="groups"
                                :multiple="true"
                                :close-on-select="false"
                                :placeholder="
                                  isAirportWithinZone(model.level2Target)
                                    ? 'Select group zone(s)'
                                    : 'Select pick up group zone(s)'
                                "
                                label="label"
                                track-by="id"
                              />
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.model.zoneGroupIds.required
                                "
                              >
                                <template
                                  v-if="isAirportWithinZone(model.level2Target)"
                                  >Group Zone is required</template
                                >
                                <template v-else
                                  >Pick-Up Group Zone is required</template
                                >
                              </small>
                            </div>
                          </div>
                          <div
                            class="col-sm-6"
                            v-if="isAirportZoneToZone(model.level2Target)"
                          >
                            <div class="form-group">
                              <div class="d-flex py-2">
                                <label class="required">
                                  Drop-Off Group Zone(s)
                                </label>
                                <button
                                  type="button"
                                  class="btn-select-all ml-5"
                                  @click="
                                    onSelectAll('destinationZoneGroupIds')
                                  "
                                >
                                  Select All
                                </button>
                                <button
                                  type="button"
                                  class="btn-clear-all ml-5"
                                  @click="onClearAll('destinationZoneGroupIds')"
                                  v-if="hasDestinationZoneGroupIds"
                                >
                                  Clear All
                                </button>
                              </div>
                              <multiselect
                                v-model="model.destinationZoneGroupIds"
                                @select="clearAmountType()"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    !$v.model.destinationZoneGroupIds.required,
                                }"
                                :options="groups"
                                :multiple="true"
                                :close-on-select="false"
                                placeholder="Select drop off group zone(s)
                                "
                                label="label"
                                track-by="id"
                              />
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.model.destinationZoneGroupIds.required
                                "
                              >
                                Drop-Off Group Zone is required
                              </small>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label class="required">Amount Type</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.amountType.$error,
                                }"
                                label="text"
                                v-model="model.amountType"
                                :options="amountTypes"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                              ></v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.model.amountType.required
                                "
                                >Amount Type is required</small
                              >
                            </div>
                          </div>
                          <!-- <div
                            class="col-sm-3"
                            v-if="model.amountType === 'Fixed'"
                          >
                            <label class="required"> Currency </label>
                            <v-select
                              class="v-search-select"
                              :class="{
                                'field-error':
                                  isSubmitted && $v.model.currency.$error,
                              }"
                              placeholder="Select currency"
                              label="text"
                              v-model="model.currency"
                              :options="currencies"
                              :clearable="true"
                              :searchable="true"
                              :filterable="true"
                              :reduce="(option) => option.value"
                            />
                            <small
                              class="form-text sts-danger"
                              v-if="isSubmitted && !$v.model.currency.required"
                            >
                              Currency is required
                            </small>
                          </div> -->
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label
                                v-if="model.amountType === 'Fixed'"
                                class="required"
                              >
                                Fixed Rate - value will be applied in the tariff
                                currency
                              </label>
                              <label
                                v-else-if="model.amountType === 'Percentage'"
                                class="required"
                              >
                                Percentage
                                <span class="--grey50">(%)</span>
                              </label>
                              <div
                                v-if="
                                  model.amountType === 'Fixed' ||
                                  model.amountType === 'Percentage'
                                "
                              >
                                <currency-input
                                  v-if="model.amountType === 'Fixed'"
                                  class="form-control"
                                  :class="{
                                    'field-error':
                                      isSubmitted && $v.model.amount.$error,
                                  }"
                                  autocomplete="off"
                                  placeholder="Enter rate"
                                  v-model="model.amount"
                                  :allow-negative="true"
                                  :currency="null"
                                  :locale="moneyFormat.cultureCode"
                                  :precision="moneyFormat.numberOfDecimal"
                                />
                                <input
                                  v-else
                                  class="form-control numbers-only"
                                  :class="{
                                    'field-error':
                                      isSubmitted && $v.model.amount.$error,
                                  }"
                                  type="text"
                                  name="percentage-markup"
                                  autocomplete="off"
                                  v-model.number="model.amount"
                                />
                                <div
                                  v-if="isSubmitted && $v.model.amount.$error"
                                >
                                  <small
                                    class="form-text sts-danger"
                                    v-if="!$v.model.amount.required"
                                    >Amount is required</small
                                  >
                                  <!-- <small
                                    class="form-text sts-danger"
                                    v-if="!$v.model.amount.minValue"
                                    >Min amount is
                                    {{
                                      $v.model.amount.$params.minValue.min
                                    }}</small
                                  > -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label class="required">Company</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.companyId.$error,
                                }"
                                placeholder=""
                                label="name"
                                v-model="model.companyId"
                                :options="companies"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.id"
                              ></v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.model.companyId.required
                                "
                                >Company is required</small
                              >
                            </div>
                          </div>
                        </div>

                        <div
                          class="modal-footer"
                          v-if="isAllowToCreate || isAllowToUpdate"
                        >
                          <button
                            type="button"
                            class="btn btn-default"
                            @click.prevent="reset()"
                          >
                            Reset
                          </button>
                          <button
                            v-if="!isUpdate && isAllowToCreate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Create
                          </button>
                          <button
                            v-if="isUpdate && isAllowToUpdate"
                            type="submit"
                            class="btn btn-primary"
                          >
                            Update
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!-- End: Form -->

                  <!-- Start: Table -->
                  <div class="table-modal-detail">
                    <div class="table-responsive table-accordion">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th class="number">No</th>
                            <th>Target</th>
                            <th>Amount</th>
                            <th>Company</th>
                            <th>Location</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in markups" :key="item.id">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ printTarget(item) }}</td>
                            <td>
                              {{
                                item.amountType === "Fixed"
                                  ? `${item.currency} ${printMoney(
                                      item.amount
                                    )}`
                                  : `${item.amount} %`
                              }}
                            </td>
                            <td>{{ item.companyName }}</td>
                            <td v-if="isAirportWithinZone(item.level2Target)">
                              {{ item.pickUpZoneName }}
                            </td>
                            <td
                              v-else-if="isAirportZoneToZone(item.level2Target)"
                            >
                              {{ item.pickUpZoneName }}
                              <p style="margin-bottom: 0; line-height: 10px">
                                &rarr;
                              </p>
                              {{ item.dropOffZoneName }}
                            </td>
                            <td v-else>
                              <template
                                v-if="item.zones && item.zones.length > 0"
                              >
                                <p
                                  class="mb-0"
                                  v-for="(zone, idxZone) in item.zones"
                                  :key="idxZone"
                                >
                                  {{ zone.name }}
                                </p>
                              </template>
                              <template v-else> - </template>
                            </td>
                            <td class="text-center">
                              <label class="cursor-pointer">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  v-model="item.isActive"
                                  :disabled="!isAllowToUpdate"
                                  @change="changeStatus(item)"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  {{ item.isActive ? "Active" : "Inactive" }}
                                </span>
                              </label>
                            </td>
                            <td class="text-center">
                              <div class="button-action-wrapper">
                                <button
                                  v-if="isAllowToUpdate"
                                  class="btn btn-default"
                                  type="button"
                                  @click="bindModel(item)"
                                >
                                  <span>Edit</span>
                                </button>
                                <button
                                  v-if="isAllowToDelete"
                                  class="btn btn-default"
                                  type="button"
                                  @click="confirmDelete(item)"
                                >
                                  <i class="ic-close"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- End: Table -->
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" @cancel="cancelDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import companyService from "@/services/master/company/companyService.js";
import regionService from "@/services/master/region/regionService.js";
import countryService from "@/services/master/countryService.js";
import sellingTariffMarkupService from "@/services/master/sellingTariff/sellingTariffMarkupService.js";
import zoneService from "@/services/master/zone/zoneService.js";
import exchangeRateService from "@/services/master/exchangeRate/exchangeRateService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    validationRuleLevel2Target: function () {
      return this.model.level1Target === "Service" ? { required } : {};
    },
    validationRuleLocation: function () {
      return this.isLocationVisible(this.model) ? { required } : {};
    },
    validationRuleCurrency: function () {
      return this.model && this.model.amountType === "Fixed"
        ? { required }
        : {};
    },
    validationRuleAmount: function () {
      return this.model &&
        (this.model.amountType === "Fixed" ||
          this.model.amountType === "Percentage")
        ? { required }
        : {};
    },
    validationRulePickUpZone: function () {
      return this.model &&
        (this.isAirportWithinZone(this.model.level2Target) ||
          this.isAirportZoneToZone(this.model.level2Target)) &&
        this.isUpdate
        ? { required }
        : {};
    },
    validationRuleDropOffZone: function () {
      return this.model &&
        this.isAirportZoneToZone(this.model.level2Target) &&
        this.isUpdate
        ? { required }
        : {};
    },
    isAirport() {
      return (
        (this.model && this.isAirportWithinZone(this.model.level2Target)) ||
        this.isAirportZoneToZone(this.model.level2Target)
      );
    },
    validationZoneGroupIds: function () {
      return this.isAirport && !this.isUpdate ? { required } : {};
    },
    validationZones: function () {
      return this.isRental(this.model.level2Target) ? { required } : {};
    },
    validationDestinationZoneGroupIds: function () {
      return this.model &&
        this.isAirportZoneToZone(this.model.level2Target) &&
        !this.isUpdate
        ? { required }
        : {};
    },
    validationGroupZone: function () {
      return this.model && this.isRental(this.model.level2Target)
        ? { required }
        : {};
    },
    hasZoneGroupIds: function () {
      return this.model.zoneGroupIds && this.model.zoneGroupIds.length;
    },
    hasZones: function () {
      return this.model.zones && this.model.zones.length;
    },
    hasDestinationZoneGroupIds: function () {
      return (
        this.model.destinationZoneGroupIds &&
        this.model.destinationZoneGroupIds.length
      );
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      isSubmitted: false,
      formatter: null,
      moneyFormat: null,
      allPermissions: [],
      selectedMasterClass: null,
      isUpdate: false,
      isItemHasBeenModified: false,
      itemToBeDeleted: null,
      level1Targets: [],
      level2Targets: [],
      amountTypes: [],
      locations: [],
      companies: [],
      defaultCompanyId: null,
      regions: [],
      countries: [],
      items: [],
      markups: [],
      zones: [],
      currencies: [],
      model: {
        pickUpZoneId: null,
        dropOffZoneId: null,
        zoneGroupIds: null,
        zones: null,
      },
      isLoading: false,
      msg: "Please wait",
      groups: [],
    };
  },
  validations() {
    return {
      model: {
        level1Target: { required },
        level2Target: this.validationRuleLevel2Target,
        companyId: { required },
        amountType: { required },
        zoneGroupIds: this.validationZoneGroupIds,
        // zoneGroupIds: this.validationGroupZone,
        // currency: this.validationRuleCurrency,
        amount: this.validationRuleAmount,
        pickUpZoneId: this.validationRulePickUpZone,
        dropOffZoneId: this.validationRuleDropOffZone,
        destinationZoneGroupIds: this.validationDestinationZoneGroupIds,
        zones: this.validationZones,
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      await this.getAllCompanies();
      await this.getAllZones();
      await this.getCurrencySelection();
      await this.getAllGroups();
      this.getAllRegions();
      this.getAllCountries();
      this.level1Targets = [
        { value: "Service", text: "Service" },
        // { value: "Surcharge", text: "Surcharge" },
        // { value: "Ancillary", text: "Ancillary" },
      ];
      this.level2Targets = [
        { value: "RentalHourly", text: "Per Hour" },
        { value: "RentalDaily", text: "Per Day" },
        { value: "RentalWeekly", text: "Per Week" },
        { value: "RentalMonthly", text: "Per Month" },
        // { value: "AirportWithinZone", text: "Transfer (Within Zone)" },
        { value: "AirportZoneToZone", text: "Transfer (Zone to Zone)" },
        // { value: "AirportDistance", text: "Transfer (Distance)" },
      ];
      this.locations = [
        { value: "Region", text: "Region" },
        { value: "Country", text: "Country" },
      ];
      if (this.moneyFormat) {
        this.formatter = new Intl.NumberFormat(this.moneyFormat.cultureCode, {
          style: "currency",
          currency: this.moneyFormat.currencyCode,
          currencyDisplay: "code",
          minimumFractionDigits: this.moneyFormat.numberOfDecimal,
        });
      }

      if (
        profile.defaultCompany &&
        this.companies &&
        this.companies.length > 0
      ) {
        const company = this.companies.find(
          (x) => x.id == profile.defaultCompany.id
        );
        if (company) {
          this.defaultCompanyId = company.id;
        }
      }
    }
  },
  updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-markup-link");
    this.$helper.numbersOnly();
  },
  methods: {
    onSelectAll(field) {
      if (field === "zoneGroupIds") {
        this.model.zoneGroupIds = this.groups;
      }

      if (field === "destinationZoneGroupIds") {
        this.model.destinationZoneGroupIds = this.groups;
      }

      if (field === "zone") {
        this.model.zones = this.zones;
      }
    },
    onClearAll(field) {
      if (field === "zoneGroupIds") {
        this.model.zoneGroupIds = null;
      }

      if (field === "destinationZoneGroupIds") {
        this.model.destinationZoneGroupIds = null;
      }

      if (field === "zone") {
        this.model.zones = null;
      }
    },
    async getAllGroups() {
      const groups = await zoneService.getAllGroups();

      if (groups) {
        this.groups = groups.map((val) => ({
          label: val.name,
          id: val.id,
          country: val.isoCountry,
        }));
      }
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async getAllZones() {
      this.zones = await zoneService.getAllActive();

      for (let i = 0; i < this.zones.length; i++) {
        const item = this.zones[i];
        item.label = `${item.group} ${item.name}`;
      }
    },
    async getCurrencySelection() {
      const response = await exchangeRateService.getCurrencySelection();
      if (response && Object.keys(response).length > 0) {
        this.currencies = Object.entries(response).map(([key, value]) => ({
          value: key,
          text: value,
        }));
      }
    },
    resetModel() {
      this.model = {
        companyId: this.defaultCompanyId,
        pickUpZoneId: null,
        dropOffZoneId: null,
        amountType: "",
        zoneGroupIds: null,
        destinationZoneGroupIds: null,
        zones: null,
      };
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.vuemodal).modal({ backdrop: "static", keyboard: false });
    },
    async closeModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.vuemodal).modal("hide");
      if (this.isItemHasBeenModified) {
        await this.getAll();
      }
    },
    bindModel(item) {
      this.isUpdate = true;
      this.resetValidations();
      // item.zoneGroupIds = [];

      // this.groups.forEach((val) => {
      //   item.zoneGroups.forEach((v) => {
      //     if (val.id === v.id) item.zoneGroupIds.push(val);
      //   });
      // });

      for (let i = 0; i < item.zones.length; i++) {
        const value = item.zones[i];
        item.zones[i].label = `${value.group} ${value.name}`;
      }

      this.model = Object.assign({}, item);
      $("#modal-markup").scrollTop(0);
    },
    reset() {
      this.isUpdate = false;
      this.resetValidations();
      this.model = {
        companyId: this.defaultCompanyId,
        pickUpZoneId: null,
        dropOffZoneId: null,
        amountType: "",
        zoneGroupIds: null,
        destinationZoneGroupIds: null,
      };
    },
    async getAll() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await sellingTariffMarkupService.getAll(filter);
        this.items = response.data.items;
        this.moneyFormat = response.data.moneyFormat;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getAllRegions() {
      this.regions = await regionService.getAllActive();
    },
    async getAllCountries() {
      this.countries = await countryService.getAll();

      for (let i = 0; i < this.countries.length; i++) {
        const item = this.countries[i];
        item.label = this.printCountry(item);
      }
    },
    async getAllCompanies() {
      if (this.companies === null || this.companies.length === 0) {
        this.companies = await companyService.getAllActive();
      }
    },
    async getMarkups(masterClassId) {
      this.markups = await sellingTariffMarkupService.getMarkups(masterClassId);
    },
    async manageMarkup(item) {
      try {
        this.isLoading = true;
        this.isItemHasBeenModified = false;
        this.selectedMasterClass = item;
        await this.getMarkups(item.masterClassId);
        this.openModal({
          companyId: this.defaultCompanyId,
          pickUpZoneId: null,
          dropOffZoneId: null,
          amountType: "",
          zoneGroupIds: null,
          destinationZoneGroupIds: null,
          zones: null,
        });
        this.isUpdate = false;
      } finally {
        this.isLoading = false;
      }
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      const zonesTemp = this.model.zones;
      const groupZonesTemp = this.model.zoneGroupIds;
      const destinationZoneGroupTemp = this.model.destinationZoneGroupIds;
      try {
        this.isLoading = true;
        this.model.masterClassId = this.selectedMasterClass.masterClassId;
        this.model.zoneGroupIds =
          this.model.zoneGroupIds &&
          this.model.zoneGroupIds.map((val) => val.id);
        this.model.zones =
          this.model.zones && this.model.zones.map((val) => val.id);
        if (
          this.isAirportZoneToZone(this.model.level2Target) &&
          !this.isUpdate
        ) {
          this.model.destinationZoneGroupIds =
            this.model.destinationZoneGroupIds.map((val) => val.id);
        }
        this.resolveProperty();
        if (!this.isUpdate) {
          await sellingTariffMarkupService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        } else {
          await sellingTariffMarkupService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        }
        this.reset();
        await this.getMarkups(this.selectedMasterClass.masterClassId);
        this.isItemHasBeenModified = true;
      } catch (error) {
        this.model.zones = zonesTemp;
        this.model.zoneGroupIds = groupZonesTemp;
        this.model.destinationZoneGroupIds = destinationZoneGroupTemp;
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        const zoneGroupIds = item.zoneGroups.map((val) => val.id);
        const paylod = {
          ...item,
          zoneGroupIds,
        };
        await sellingTariffMarkupService.update(paylod);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.getMarkups(this.selectedMasterClass.masterClassId);
        this.isItemHasBeenModified = true;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await sellingTariffMarkupService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getMarkups(this.selectedMasterClass.masterClassId);
        this.isItemHasBeenModified = true;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          $("body").addClass("modal-open");
        }, 500);
      }
    },
    cancelDelete() {
      setTimeout(() => {
        $("body").addClass("modal-open");
      }, 500);
    },
    printMoney(value) {
      return this.formatter
        ? this.formatter
            .format(value)
            .replace(/[a-z]{3}/i, "")
            .trim()
        : value;
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    resolveProperty() {
      this.model.amount = parseFloat(this.model.amount);
      switch (this.model.level1Target) {
        case "Service":
          if (this.model.level2Target === "AirportWithinZone") {
            this.model.airportZoneDestinationType = "WithinZone";
            this.model.dropOffZoneId = null;
          }
          if (this.model.level2Target === "AirportZoneToZone") {
            this.model.airportZoneDestinationType = "ZoneToZone";
          }
          break;
        case "Surcharge":
        case "Ancillary":
          delete this.model.level2Target;
          break;
      }
    },
    isLocationVisible(item) {
      return item &&
        item.level1Target &&
        item.level1Target.toLowerCase() === "service" &&
        item.level2Target &&
        (item.level2Target.toLowerCase() === "airportwithinzone" ||
          item.level2Target.toLowerCase() === "airportzonetozone")
        ? false
        : true;
    },
    printTarget(item) {
      switch (item.level1Target) {
        case "Service":
          return `${item.level1Target} - ${this.$helper.humanize(
            item.level2Target
          )}`;
        case "Surcharge":
        case "Ancillary":
          return item.level1Target;
        default:
          return null;
      }
    },
    printCountry(item) {
      return item && item.name !== null && item.name !== ""
        ? `${item.name} (${item.iata})`
        : item.iata;
    },
    isAirportWithinZone(level2Target) {
      return level2Target === "AirportWithinZone";
    },
    isAirportZoneToZone(level2Target) {
      return level2Target === "AirportZoneToZone";
    },
    isRental(level2Target) {
      return (
        level2Target === "RentalHourly" ||
        level2Target === "RentalDaily" ||
        level2Target === "RentalWeekly" ||
        level2Target === "RentalMonthly"
      );
    },
    isEqualCountry(equal) {
      if (equal) {
        return (this.amountTypes = [
          { value: "Fixed", text: "Fixed" },
          { value: "Percentage", text: "Percentage" },
        ]);
      } else {
        return (this.amountTypes = [
          { value: "Percentage", text: "Percentage" },
        ]);
      }
    },
    clearAmountType() {
      this.model.amountType = "";
    },
  },
  watch: {
    "model.zones": {
      deep: true,
      handler: function (value) {
        if (value) {
          const equal = value.every(
            (val, i, arr) => val.isoCountry === arr[0].isoCountry
          );
          this.isEqualCountry(equal);
        }
      },
    },
    "model.zoneGroupIds": {
      deep: true,
      handler: function (value) {
        const destinationGroup = this.model.destinationZoneGroupIds;
        if (value && destinationGroup) {
          const concatZones = value.concat(destinationGroup);
          const equal = concatZones.every(
            (val, i, arr) => val.country === arr[0].country
          );
          this.isEqualCountry(equal);
        } else if (value) {
          const equal = value.every(
            (val, i, arr) => val.country === arr[0].country
          );
          this.isEqualCountry(equal);
        }
      },
    },
    "model.destinationZoneGroupIds": {
      deep: true,
      handler: function (value) {
        const zoneGroup = this.model.zoneGroupIds;
        if (value && zoneGroup) {
          const concatZones = value.concat(zoneGroup);
          const equal = concatZones.every(
            (val, i, arr) => val.country === arr[0].country
          );
          this.isEqualCountry(equal);
        } else if (value) {
          const equal = value.every(
            (val, i, arr) => val.country === arr[0].country
          );
          this.isEqualCountry(equal);
        }
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/sellingTariff/Markup.vue